export default __webpack_public_path__ + "486bf579358f316d1110eb7f92dbcc8a.svg";